export const openChatSupport = () => {
  if (window.Gleap) {
    try {
      window.Gleap.open();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn('Failed to open Gleap chat:', error);
    }
  }
};
